<template>
	<div style="display:none">

	</div>
</template>

<script>
import {mapState} from "vuex";
export default {
	name: 'CabinetBedCalculator',
	components: {},
	mixins: [],
	props: {},
	data() {
		return {}
	},
	mounted() {
		if(!document.cabinetBedCalculator){
			document.cabinetBedCalculator = this;
			this.calculateTotals();
		}
	},
	methods: {
		calculateTotals(){
			
			let pricingItems =  {
				cabinet_bed_id: this.cabinetBed.id,
				color_id : this.cabinetBedColor ? this.cabinetBedColor.id : null,
				selected_options: [],
				mattress_id : this.selectedMattress ? this.selectedMattress.id : null,
				type: this.cabinetBed.type,
			};
			
			let bedPrice = this.tryFloat(this.cabinetBed.price);
			let colorUpcharge = this.cabinetBedColor ? this.tryFloat(this.cabinetBedColor.price) : 0;
			let total = 0;
			let totals = {...this.priceTotals};
			totals.base = bedPrice;
			totals.color_upcharge = colorUpcharge;
			total += bedPrice;
			total += colorUpcharge;
			
			let optionsTotal = 0;
			
			for(let i = 0; i < this.selectedOptions.length; ++i){
				pricingItems.selected_options.push(this.selectedOptions[i].id);
				optionsTotal += this.tryFloat(this.selectedOptions[i].price);
			}
			totals.mattress = this.selectedMattress ? this.selectedMattress.enabled_title : this.mattresses[0].disabled_title;
			totals.mattress_price = this.selectedMattress ? this.tryFloat(this.selectedMattress.price) : 0;
			totals.additional = optionsTotal;
			
			total += totals.mattress_price;
			total += totals.additional;
			totals.pricing = pricingItems;

			// Cabinet beds carry a single bed-level discount, the way wallbeds do
			// in Layout/Header.vue. originalPrice + discounts are what QuickBuilder
			// reads to render the struck-through price.
			let discounts = [];
			if(this.useDiscounts && this.cabinetBed.discount_amount){
				let discount = this.tryFloat(this.cabinetBed.discount_amount);
				if(discount){
					discounts.push(discount);
				}
			}

			totals.originalPrice = total;
			for(let i in discounts){
				total -= discounts[i];
			}
			totals.total = total;
			totals.discounts = discounts;

			this.$store.commit('setTotals', totals);
			this.$store.commit('setPricingItems', pricingItems);
		}
	},
	computed: {
		...mapState({
			cabinetBed: state => state.cabinetBed,
			cabinetBedColor: state => state.cabinetBedColor,
			priceTotals: state => state.totals,
			useDiscounts: state => state.useDiscounts,
			selectedOptions: state => state.selected_options,
			selectedMattress: state => state.selected_mattress,
			mattresses: state => state.mattresses,
		})
	},
	watch: {
		//don't watch priceTotals. Memory gets eaten up and breaks the page.
	}
}
</script>